<div id="about" class="why-choose pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4">
                <div class="why-choose-img wow fadeInUp" data-wow-duration="1s">
                    <img
                        src="assets/img/app-landing/img_2.jpeg"
                        alt="why choose image"
                    />
                </div>
            </div>
            <div class="col-lg-7 offset-lg-1">
                <div
                    class="why-choose-text wow fadeInUp"
                    data-wow-duration="2s"
                >
                    <div class="section-title">
                        <span>
                            لماذا تختارنا؟
                            <!-- Why Choose Us? -->
                        </span>
                        <h2>
                            نحن نقدم أفضل حل!
                            <!-- We are Providing the Best facilities! -->
                        </h2>
                        <p>
                            Trackids هنا لتزويدك بأفضل الحلول للعثور على الأطفال
                            المفقودين. مع هذا التطبيق ، لا داعي للقلق بشأن
                            بياناتك وسجل قضيتك فقط. نحن نقدم حلاً جديرًا بالثقة
                            للعثور على أطفالك.
                            <!-- Euzan is here to provide you with the best experience of booking tickets online. With this app, you do not have to worry about traveling miles and buying tickets way ahead of time. We provide a trustworthy solution to begin your journey. -->
                        </p>
                    </div>
                    <div class="media d-flex">
                        <i class="flaticon-computer mr-3"></i>
                        <div class="media-body">
                            <h3 class="mt-0">
                                واجهة مستخدم سهلة
                                <!-- Clean User Interface -->
                            </h3>
                            التطبيق سهل التعامل معه والاستخدام.
                            <br />
                            لن تضطر إلى التساؤل كثيرًا حيث يمكنك الانتقال إلى
                            تسجيل قضيتك.
                            <!-- The app is easy to handle and understand. You will not have to wonder much and just jump to booking your destination ticket. -->
                        </div>
                    </div>
                    <div class="media d-flex">
                        <i class="flaticon-clipboard mr-3"></i>
                        <!-- <i class="flaticon-cinema mr-3"></i> -->
                        <div class="media-body">
                            <h3 class="mt-0">
                                سجل القضايا
                                <!-- Comfort Booking -->
                            </h3>
                            لا تقلق فقط قم بتسجيل قضيتك في وقت مبكر أو على الفور
                            عند حدوث الاختطاف. التطبيق يمكن التحكم فيه بسهولة.
                            <!-- Don’t worry just book your tickets ahead of time or instantly while sipping a coffee or while taking a walking. The app is easily manageable. -->
                        </div>
                    </div>
                    <div class="media d-flex">
                        <i class="flaticon-countdown mr-3"></i>
                        <div class="media-body">
                            <h3 class="mt-0">
                                توفير الوقت
                                <!-- Time-Saving -->
                            </h3>
                            قم بتسجيل الحالة للعثور على الطفل المفقود باستخدام
                            Trackids في غضون فترة زمنية قصيرة
                            <!-- We know how hectic life can be. Book the ticket for your target destination with Euzan within a second. Take the extra time to pack properly. -->
                        </div>
                    </div>
                    <!-- <div class="media d-flex">
                        <i class="flaticon-wallet mr-3"></i>
                        <div class="media-body">
                            <h3 class="mt-0">Online Payment</h3>
                            We accept online payment. Manage your trip without the hassle of buying the ticket in person or paying for it in cash. Just transfer the money online.
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
